module.exports = __webpack_public_path__ + "static/media/reckless-neue-heart-regular.2b9f29c8.woff2";